import React from "react";
import { useMediaQuery } from "@mui/material";
import CheckIcon from "/Images/cekidot.svg"; // Checklist icon
import DeployImage from "/Images/assetwhytennet.png"; // Gambar deployment
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"; // Ikon panah dari Material UI

const DeploymentSection = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const isMobile2 = useMediaQuery("(max-width: 400px)");

  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column-reverse" : "row",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#E0DCD9",
      padding: isMobile2 ? "30px 10px" : isMobile ? "50px 20px" : "100px",
      borderRadius: "10px",
    },
    textContainer: {
      paddingRight: isMobile ? "0" : "20px",
      display: "flex",
      flexDirection: "column",
      width: isMobile ? "100%" : "45%",
      marginBottom: isMobile ? "20px" : "0",
      maxWidth: "616px",
    },
    imageContainer: {
      flex: 1,
      display: "flex",
      justifyContent: isMobile ? "center" : "flex-start",
      alignItems: "center",
      width: isMobile ? "100%" : "50%",
      marginBottom: isMobile ? "20px" : "0",
      marginLeft: isMobile ? "0px" : "60px"
    },
    image: {
      width: isMobile2 ? "70%" : isMobile ? "80%" : "90%",
      maxWidth: isMobile ? "400px" : "574px",
      borderRadius: "10px",
    },
    heading: {
      color: "#214D73",
      fontSize: isMobile2 ? "15px" : isMobile ? "20px" : "30px",
      fontWeight: "600",
      marginBottom: "20px",
      width: "400px",
    },
    listItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: "10px",
      marginBottom: "20px",
    },
    listIcon: {
      height: isMobile2 ? "12px" : isMobile ? "15px" : "20px",
      marginTop: "4px",
    },
    listDescription: {
      fontSize: isMobile2 ? "0.75rem" : isMobile ? "0.875rem" : "1rem",
      color: "#6D6D6D",
      lineHeight: "1.5",
      margin: 0,
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.textContainer}>
        <h2 style={styles.heading}>
          Building Trust with
          Advanced Wallet Security
        </h2>
        <div style={styles.listItem}>
          <img src={CheckIcon} alt="Check" style={styles.listIcon} />
          <p style={styles.listDescription}>
            We use HSMs certified FIPS 140-2 Level 3 to custody and protect
            master keys, perform key derivation, and run our policy engine.
          </p>
        </div>

        <div style={styles.listItem}>
          <img src={CheckIcon} alt="Check" style={styles.listIcon} />
          <p style={styles.listDescription}>
            We harden HSMs with our proprietary firmware extension, which
            enforce HSMs’ secure configuration and reduces their attack surface.
          </p>
        </div>

        <div style={styles.listItem}>
          <img src={CheckIcon} alt="Check" style={styles.listIcon} />
          <p style={styles.listDescription}>
            Signatures by hardware tokens provide multi-party approval using a
            quorum logic not visible from blockchain data.
          </p>
        </div>
      </div>
      <div style={styles.imageContainer}>
        <img src={DeployImage} alt="Deployment" style={styles.image} />
      </div>
    </div>
  );
};

export default DeploymentSection;
